import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, DEFAULT_PAGE_SIZE, IntegrationsGridGetRowsResponse } from '../types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../../utils/request.utils';
import { Filter } from '../../../grid/gridFilters/types';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';

export default class IntegrationsGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private pageSize: number = DEFAULT_PAGE_SIZE;
  private unfilteredRowsTotal: number;
  private filters: Array<Filter<ColumnKeys>>;
  private records: any;

  constructor(public dependencies: any) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    request.pageSize = this.pageSize;
    const params = {
      pageSize: request.pageSize,
      pageNumber: request.pageNumber,
      filters: convertGridFiltersToExtJsFilters(this.filters),
    };
    const response = await this.dependencies.api.clients.SensorsIntegrations.readRecords(
      params,
      getRequestDefaultOptions()
    );
    this.records = response;

    return sanitizeObject({
      summary: `${response.total} items`,
      numItems: response.total,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<IntegrationsGridGetRowsResponse> {
    request.pageSize = this.pageSize;
    this.unfilteredRowsTotal = this.records.unfilteredTotal;
    return sanitizeObject({ rawEvents: this.records.data });
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    this.pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;

    return {};
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    this.filters = request.filters;
    return;
  }

  /**
   * @throws {Error}
   */
  getUnfilteredRowsTotal(): number {
    if (undefined === this.unfilteredRowsTotal) {
      throw new Error('Cannot determine the unfiltered rows total without fetching the rows first.');
    }

    return this.unfilteredRowsTotal;
  }
}
